
export interface SimpleApiResponse {
  /** 응답 코드 */
  code?: string;
  /** 결과 메시지 */
  message?: string;
  /** 작업 성공 여부 */
  success?: boolean;
}
